import { lazy } from 'react';

// ----------------------------------------------------------------------

const CarPage = lazy(() => import('../pages/car.page'));
const CarsListPage = lazy(() => import('../pages/carsList.page'));
const AddCarPage = lazy(() => import('../pages/addCar.page'));
const EditCarPage = lazy(() => import('../pages/editCar.page'));
const CarDetailsPage = lazy(() => import('../pages/carDetails.page'));
const AddFleetPage = lazy(() => import('../pages/addFleet.page'));

// ----------------------------------------------------------------------

const CarRoutes = [
    {
        path: 'cars',
        children: [
            {
                element: <CarPage />,
                layout: 'default',
                isAuthReq: true,
                index: true,
            },
            {
                path: 'list',
                element: <CarsListPage />,
                layout: 'default',
                isAuthReq: true,
            },
            {
                path: 'add-car',
                element: <AddCarPage />,
                layout: 'default',
                isAuthReq: true,
            },
            {
                path: ':id',
                element: <CarDetailsPage />,
                layout: 'default',
                isAuthReq: true,
            },
            {
                path: ':id/edit',
                element: <EditCarPage />,
                layout: 'default',
                isAuthReq: true,
            },
            {
                path: 'add-fleet',
                element: <AddFleetPage />,
                layout: 'default',
                isAuthReq: true,
            },
        ],
    },
];

export { CarRoutes };
